import { render, staticRenderFns } from "./WeightsSetDeleter.vue?vue&type=template&id=2ad5571a&scoped=true"
import script from "./WeightsSetDeleter.vue?vue&type=script&lang=ts"
export * from "./WeightsSetDeleter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad5571a",
  null
  
)

export default component.exports